/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import { FormProvider } from 'react-hook-form';
import { AdvisorySection } from './AdvisorySection';
import { AssetAdvisoryFormValues, ASSETS_SECTION_FIELDS, useAssetAdvisoryForm } from './useAssetAdvisoryForm';
import { getCSRF } from '../../../utils/forms';
import { createRecommendationValidatedEvent } from '../common/events';
import { JsonPropsType } from '../../../component-loader';

interface AssetAdvisoryFormProps {
  default_values: AssetAdvisoryFormValues
}

export function AssetAdvisoryForm(props: JsonPropsType) {
  const {
    default_values,
  } = props.jsonObject as AssetAdvisoryFormProps;
  const {
    methods,
    handleSubmit,
  } = useAssetAdvisoryForm(default_values);

  const { name: CSRFName, value: CSRFValue } = getCSRF();
  const formRef = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    const atLeastOneFieldFilled = methods
      .getValues(ASSETS_SECTION_FIELDS).some((v) => v !== null && v !== 0);
    window.dispatchEvent(createRecommendationValidatedEvent('asset_advisory', methods.formState.isValid && atLeastOneFieldFilled));
  }, [methods.formState]);
  return (
    <FormProvider {...methods}>
      <form
        id="asset-advisory-form"
        className="row justify-content-center g-5"
        method="post"
        onSubmit={methods.handleSubmit(handleSubmit)}
        ref={formRef}
      >
        <input type="hidden" name={CSRFName} value={CSRFValue} />
        <input type="hidden" name="action" value="" />

        <div className="col p-0 m-0">
          <AdvisorySection />
        </div>
      </form>
    </FormProvider>
  );
}
